import localeData from '../../helpers/login.lang'
import {language} from '../../helpers/login.data'

const locale = localeData[language]

export const requirementsNames = {
  minLength: value => locale.minLength({minLength: value}),
  minUpperCase: value => locale.minUpperCase({minUpperCase: value}),
  minLowercase: value => locale.minLowercase({minLowercase: value}),
  minNumbers: value => locale.minNumbers({minNumbers: value}),
  minSpecial: value => locale.minSpecial({minSpecial: value})
}

export const isPasswordRequirementInvalid = ({password, minLength, minLowercase, minUpperCase, minNumbers, minSpecial}) => {
  if (minLength && (password.length < minLength)) {
    return true
  }
  if (minLowercase && (password.replace(/[^a-z]/g, '').length < minLowercase)) {
    return true
  }
  if (minUpperCase && (password.replace(/[^A-Z]/g, '').length < minUpperCase)) {
    return true
  }
  if (minNumbers && (password.replace(/\D/g, '').length < minNumbers)) {
    return true
  }
  if (minSpecial && (password.replace(/[a-zA-Z0-9]/g, '').length < minSpecial)) {
    return true
  }
  return false
}
